// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollableJumbo_root__D3uO9","heading":"ScrollableJumbo_heading__PXA3V","description":"ScrollableJumbo_description__c84YZ"};